import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// material
import { styled, useTheme } from '@mui/material/styles';
// hooks
import { useCollapseDrawer } from '../../hooks/useCollapseDrawer';
import { observer } from 'mobx-react-lite';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { Stack } from '@mui/material';
import { pxToRem } from 'src/theme/typography';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  // overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default observer(function DashboardLayout() {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);
  const DRAWER_WIDTH = `300px`;

  return (
    // <RootStyle>
    <>
      <DashboardSidebar />
      <Stack sx={{ width: '100%', pl: DRAWER_WIDTH, pr: pxToRem(20), py: pxToRem(20) }}>
        <Outlet />
      </Stack>
    </>
    // </RootStyle>
  );
});
